import gql from 'graphql-tag';
import OrderRow from './fragmentOrderRow';

export default gql`
  mutation PublishShortedOrder($input: PublishShortedOrderInput!) {
    publishShortedOrder(input: $input) {
      order {
        ...OrderRow

        # Below are 'Shorts' tab specific data
        # We don't want to add these to OrderRow
        # Because boxes is expensive and unused in other tabs
        boxesRequested
        boxesShort
        boxesScanned
        publishedAt
        wave {
          isFullyPublished
        }
      }
    }
  }
  ${OrderRow}
`;



// WEBPACK FOOTER //
// ./src/queries/publishShortedOrder.js